/** Money + date formatting shared by every dealer page. */

function major(minor: number | null | undefined): string {
  const value = (minor ?? 0) / 100;
  // Whole shillings stay clean; fractional ones keep their true value.
  return value.toLocaleString("en-TZ", {
    minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
    maximumFractionDigits: 2,
  });
}

export function tzs(minor: number | null | undefined): string {
  return `TZS ${major(minor)}`;
}

export function tzsPlain(minor: number | null | undefined): string {
  return major(minor);
}

/** "12500" | "12,500" (major units, as typed) → minor units. */
export function toMinor(majorText: string): number | null {
  const cleaned = majorText.replace(/[,\s]/g, "");
  if (!/^\d{1,12}(\.\d{1,2})?$/.test(cleaned)) return null;
  const [whole, frac = ""] = cleaned.split(".");
  const frac2 = (frac + "00").slice(0, 2);
  return Number(whole) * 100 + Number(frac2);
}

export function shortDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

export function dateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return `${d.toLocaleDateString("en-GB", { day: "2-digit", month: "short" })} · ${d.toLocaleTimeString(
    "en-GB",
    { hour: "2-digit", minute: "2-digit" },
  )}`;
}
